import React from "react";

export function CurrentViewBadge({
	isCurrentView,
}: {
	isCurrentView: boolean;
}) {
	if (!isCurrentView) {
		return null;
	}

	return <span className="badge">Current View</span>;
}
